import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';

import ParkerProtectionGuaranteeZHHK from '../../components/10General/ParkerProtectionGuarantee_zh_HK';
import ParkerProtectionGuaranteeENUS from '../../components/10General/ParkerProtectionGuarantee_en_US';
import {getTnc} from "../../utils/04Api/Tnc";

class ParkerProtectionGuarantee extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parkerProtectionGuarantee: null,
        }
    }

    componentDidMount() {

        this.ApiGetparkerProtectionGuarantee(this.ApiGetparkerProtectionGuarantee);
    }

    ApiGetparkerProtectionGuarantee = (errorCallback) => {

        let callback = (res) => {

            if (res.status === 200) {

                this.setState({
                    ...this.state,
                    parkerProtectionGuarantee: res.body
                })
            }
        }

        getTnc('parker_protection_guarantee', callback, errorCallback);
    }

    render() {

        const {
            t,
            i18n
        } = this.props;

        // console.log(this.state.parkerProtectionGuarantee);

        return (
            <div className="wrapper-container media">

                <div className="page-title"><h2>{t("Menu.ParkerProtectionGuarantee")}</h2></div>

                <div className="sep-0"/>

                <div className="containerMain">
                    <div className="content clearfix">
                        {i18n.language === 'zh-HK'
                            ? this.state.parkerProtectionGuarantee !== null ?
                                <ParkerProtectionGuaranteeZHHK
                                    content={this.state.parkerProtectionGuarantee['zh-hk'].ppg_content_chi.value}/> : ''
                            : this.state.parkerProtectionGuarantee !== null ?
                                <ParkerProtectionGuaranteeENUS
                                    content={this.state.parkerProtectionGuarantee['en-us'].ppg_content_eng.value}/> : ''
                        }
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = (state) => (
// 	{
// 	}
// );

export default withTranslation()(ParkerProtectionGuarantee);
